import type { ThemeConfig as AntdThemeConfig } from "antd";
import type { LayoutType } from "@ifa/utils";

import type { TenantBrandTheme } from "../core/types.ts";
import { PAD_THEME_FOUNDATION } from "../core/pad-foundation.ts";

export interface CreateAntdThemeOptions {
  layoutType?: LayoutType;
}

function getPadAntdTokenOverrides(): NonNullable<AntdThemeConfig["token"]> {
  return {
    fontSize: PAD_THEME_FOUNDATION.fontSize.base,
    fontSizeSM: PAD_THEME_FOUNDATION.fontSize.sm,
    fontSizeLG: PAD_THEME_FOUNDATION.fontSize.lg,
    fontSizeXL: PAD_THEME_FOUNDATION.fontSize.xl,
    lineHeight: PAD_THEME_FOUNDATION.lineHeight,
    borderRadius: PAD_THEME_FOUNDATION.radii.md,
    borderRadiusSM: PAD_THEME_FOUNDATION.radii.sm,
    borderRadiusLG: PAD_THEME_FOUNDATION.radii.lg,
    borderRadiusXS: PAD_THEME_FOUNDATION.radii.sm,
    boxShadow: PAD_THEME_FOUNDATION.shadow.medium,
    boxShadowSecondary: PAD_THEME_FOUNDATION.shadow.small,
    boxShadowTertiary: PAD_THEME_FOUNDATION.shadow.large,
  };
}

export function toAntdTheme(
  theme: TenantBrandTheme,
  options?: CreateAntdThemeOptions
): AntdThemeConfig {
  return {
    token: {
      colorPrimary: theme.primary,
      colorLink: theme.primary,
      fontFamily: theme.fontFamily,
      borderRadius: theme.radii.md,
      ...(options?.layoutType === "pad" ? getPadAntdTokenOverrides() : {}),
    },
  };
}

export function createAntdTheme(
  theme: TenantBrandTheme,
  options?: CreateAntdThemeOptions,
  customConfig?: Partial<AntdThemeConfig>
): AntdThemeConfig {
  const baseTheme = toAntdTheme(theme, options);

  if (!customConfig) {
    return baseTheme;
  }

  return {
    token: {
      ...baseTheme.token,
      ...customConfig.token,
    } as AntdThemeConfig["token"],
    components: customConfig.components,
    algorithm: customConfig.algorithm,
    hashed: customConfig.hashed,
    inherit: customConfig.inherit,
  };
}
